import { component } from "picoapp";
import { CAROUSEL_INTERSECTION_SETTINGS } from "../Carousels/tbsp-carousel--constants";

export const explodingPan = component(async (node: HTMLElement) => {
  const [{ default: Splide }, { Intersection }] = await Promise.all([
    import("@splidejs/splide"),
    import("@splidejs/splide-extension-intersection"),
    // @ts-ignore
    import("@splidejs/splide/css/core"),
  ]);

  const aside = node.querySelector("aside");

  const main = new Splide(aside, {
    arrows: false,
    drag: false,
    speed: 0,
    pagination: true,
    paginationDirection: "ttb",
    focus: 0,

    ...CAROUSEL_INTERSECTION_SETTINGS,
  });

  main.on("pagination:mounted", ({ list, items }) => {
    list.classList.add("flex-row", "md:flex-col", "!flex");
    items.forEach((item, idx) => {
      item.button.classList.add("ripple-button");
      item.button.textContent = String(item.page + 1);
      const liClass = ["md:!mb-6", "!mr-6", "md:!mr-0", "ripple", "last:!mr-0"];
      item.li.classList.add(...liClass);

      const target = node.querySelectorAll<HTMLElement>(
        "[data-tbsp-hotspot] button"
      )[idx];

      if (target) {
        Object.keys(target.dataset).forEach((k) => {
          item.button.dataset[k] = target.dataset[k];
        });
      }
    });
  });

  main.on("mounted", () => {
    const hotSpots = node.querySelectorAll<HTMLElement>("[data-tbsp-hotspot]");
    hotSpots.forEach((hotSpot) =>
      hotSpot.addEventListener("click", () => {
        main.Components.Controller.go(parseInt(hotSpot.dataset.index), false);
      })
    );
  });

  main.on("active", (Slide) => {
    const activeIndex = Slide.index;
    const activeHotSpot = node.querySelector(`[data-tbsp-hotspot] .is-active`);
    activeHotSpot.classList.remove("is-active");
    const newHotSpot = node.querySelector(
      `[data-tbsp-hotspot][data-index='${activeIndex}']`
    );
    newHotSpot.querySelector("button").classList.add("is-active");
  });

  main.mount({ Intersection });
});
